import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Button, { BUTTON_HEIGHT_24 } from '../../../Button'

import * as styles from './BirdviewControlOption.module.css'

function BirdviewControlOption({ isActive, option, onSelect }) {
  const { t } = useTranslation()

  function handleClick() {
    onSelect(option.value)
  }

  return (
    <Button.Flat
      isGrey
      className={classNames(styles.option, { [styles.active]: isActive })}
      height={BUTTON_HEIGHT_24}
      isActive={isActive}
      qaName={option.qaName}
      text={t(option.labelKey)}
      onClick={handleClick}
    />
  )
}

export default BirdviewControlOption
